import Lottie from 'lottie-react';

import lottieDriverLicense from '../jsons/drivers-license.json';

const LottieDriverLicense = props => {
  return <Lottie animationData={lottieDriverLicense} loop={false} {...props} />;
};

export default LottieDriverLicense;
